import axios from 'axios';
import { toast } from 'react-toastify';
const BaseURL = process.env.REACT_APP_API_PATH;

export const rejectDocument = async (data) => {
    const response = await axios.put(`${BaseURL}/ebench/reject-document`, data);
    return response.data;
};

export const JobCountStats = async (id) => {
    const response = await axios.get(`${BaseURL}/ebench/getJobCount?vendorId=${id}`);
    return response.data;
};

export const ActivateVendor = async (id) => {
    try {
        const response = await axios.put(`${BaseURL}/ebench/vendor/activate?vendorId=${id}`);
        toast.success('Vendor activated successfully!');
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message);
        throw error;
    }
};

export const DeactivateVendor = async (id) => {
    try {
        const response = await axios.put(`${BaseURL}/ebench/vendor/deactivate?vendorId=${id}`);
        toast.success('Vendor deactivated successfully!');
        return response;
    } catch (error) {
        toast.error(error?.response?.data?.status?.message);
        throw error;
    }
};
